import { platform } from 'constants'
import React from 'react'

import { Box } from 'widgets/Box'
import { CoachItem } from 'widgets/CoachItem'
import { FlatList } from 'widgets/FlatList'
import { Title } from 'widgets/Title'

import commonStyles from 'utils/styles/commonStyles'

import { UserType } from 'types/user'

export const EmergingCoaches = ({
  isFeedHeader = false,
  discoverContent,
  isLoadingDiscoverContent,
  emergingCoaches,
  isLoadingEmergingCoaches,
}) => {
  return (
    <>
      {!isFeedHeader && !isLoadingDiscoverContent && (
        <Title bold>{discoverContent?.sections[0]?.name}</Title>
      )}
      {!!isLoadingEmergingCoaches && (
        <Box
          testID='EmergingCoachesRow'
          flexDirection={emergingCoaches && emergingCoaches.length > 0 ? 'row' : 'column'}
          justifyContent='flex-start'
          width='100%'
          margin={{
            top: !isFeedHeader ? 'sm' : undefined,
            bottom: !isFeedHeader ? 'md' : undefined,
          }}
          padding={{ bottom: 'smd' }}
          style={platform.IS_WEB ? commonStyles.overflowScroll : undefined}
        >
          <FlatList<UserType>
            horizontal
            data={emergingCoaches?.filter((coach) => !!coach)}
            loading={isLoadingEmergingCoaches}
            renderItem={({ item: user }) => (
              <CoachItem user={user} isSquare isFeedHeader={isFeedHeader} />
            )}
            keyExtractor={(user) => `EmergingCoaches-${user?.id}`}
            testID='EmergingCoachesList'
            noContentProps={{
              marginTop: 50,
              marginBottom: 50,
              message: 'No Groups are emerging right now',
            }}
            contentContainerStyle={commonStyles.flexGrow}
          />
        </Box>
      )}
    </>
  )
}
